import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.reduce.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import React from "react";
import { MDXProvider, withMDXComponents } from "@mdx-js/react";
import { MDXScopeProvider } from "./context";
/**
 * so, this import is weird right?
 *
 * # What it looks like:
 * we're importing a webpack loader directly into our runtime bundle
 *
 * # What it's actually doing:
 * We configure the `mdx-components` loader in gatsby-node's
 * `onCreateWebpackConfig`. The configuration sets the loader to handle its
 * own file, so if we import `./loaders/mdx-components`, the `mdx-components`
 * loader handles loading itself.
 *
 * # Why does this work?
 * The loader doesn't use the file argument to itself and instead returns
 * a generated file that includes the `gatsby-config` mdxPlugins wrapped in
 * require() statements. This results in the `mdxPlugins` being required
 * and available to the code after this import.
 *
 * # Have a better solution to this?
 * Submit a PR
 */

import { plugins as mdxPlugins } from "./loaders/mdx-components";
import scopeContexts from "./loaders/mdx-scopes";
import { jsx as ___EmotionJSX } from "@emotion/core";
var componentsAndGuards = {};

var componentFromGuards = function componentFromGuards(arr) {
  return function GatsbyMDXComponentFinder(props) {
    var _arr$find = arr.find(function (_ref) {
      var guard = _ref.guard;
      return guard ? guard(props) : true;
    }),
        Component = _arr$find.Component;

    return ___EmotionJSX(Component, props);
  };
};

mdxPlugins.forEach(function (_ref2) {
  var _ref2$guards = _ref2.guards,
      guards = _ref2$guards === void 0 ? {} : _ref2$guards,
      components = _ref2.components;
  Object.entries(components).forEach(function (_ref3) {
    var componentName = _ref3[0],
        Component = _ref3[1];

    if (componentsAndGuards[componentName]) {
      componentsAndGuards.push({
        guard: guards[componentName],
        Component: Component
      });
    } else {
      componentsAndGuards[componentName] = [{
        guard: guards[componentName],
        Component: Component
      }];
    }
  });
});
var components = Object.entries(componentsAndGuards).map(function (_ref4) {
  var _ref5;

  var name = _ref4[0],
      arr = _ref4[1];
  return _ref5 = {}, _ref5[name] = componentFromGuards(arr.concat({
    guard: undefined,
    Component: name
  })), _ref5;
}).reduce(function (acc, obj) {
  return _objectSpread(_objectSpread({}, acc), obj);
}, {}); // merge any components in wrapRootElement above this wrapRoot

var MDXConsumer = withMDXComponents(function (_ref6) {
  var componentsFromContext = _ref6.components,
      children = _ref6.children;
  return ___EmotionJSX(MDXScopeProvider, {
    __mdxScope: scopeContexts
  }, ___EmotionJSX(MDXProvider, {
    components: _objectSpread(_objectSpread({}, componentsFromContext), components)
  }, children));
});

var WrapRootElement = function WrapRootElement(_ref7) {
  var element = _ref7.element;
  return ___EmotionJSX(MDXConsumer, null, element);
};

export default WrapRootElement;

if (typeof WrapRootElement !== 'undefined' && WrapRootElement && WrapRootElement === Object(WrapRootElement) && Object.isExtensible(WrapRootElement) && !WrapRootElement.hasOwnProperty('__filemeta')) {
  Object.defineProperty(WrapRootElement, '__filemeta', {
    configurable: true,
    value: {
      name: "WrapRootElement",
      filename: "node_modules/gatsby-plugin-mdx/wrap-root-element.js"
    }
  });
}